import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "../../layouts/Layout";
import "./LegalServices.css";
import LegalSolutions from '../../assets/img/images/legal-solutions.jpg'
import whychooseus from '../../assets/img/images/whychooseus-legal.jpg'



const serviceItems = [
  {
    title: "Corporate & Commercial Law",
    text: "Business-focused legal guidance for corporate matters, commercial arrangements, governance issues and day-to-day legal decisions.",
  },
  {
    title: "Agreement Drafting & Contract Review",
    text: "Clear, enforceable agreements drafted and reviewed to protect your commercial interests and reduce future disputes.",
  },
  {
    title: "Mergers, Acquisitions & Restructuring",
    text: "Legal support for transaction planning, due diligence, restructuring, documentation, negotiations and regulatory coordination.",
  },
  {
    title: "Intellectual Property Advisory",
    text: "Practical advice to identify, protect, use and manage trademarks, copyrights, business names and other intellectual assets.",
  },
  {
    title: "Employment, Labour & Real Estate Advisory",
    text: "Business-oriented support for employment documentation, labour matters, property transactions and real estate legal review.",
  },
  {
    title: "Notices, Documentation & Dispute Support",
    text: "Professional assistance with legal notices, replies, civil documentation, regulatory interpretation and commercial dispute strategy.",
  },
];

const processSteps = [
  {
    number: "01",
    title: "Legal Consultation",
    text: "We understand the transaction, dispute, document or business issue and identify your commercial and legal objectives.",
  },
  {
    number: "02",
    title: "Risk Analysis",
    text: "Our team reviews the available facts, documents, obligations and potential exposure before recommending the right approach.",
  },
  {
    number: "03",
    title: "Drafting & Review",
    text: "Agreements, notices, replies and supporting documents are prepared or reviewed with accuracy and commercial clarity.",
  },
  {
    number: "04",
    title: "Advisory & Representation",
    text: "We support negotiations, regulatory interactions, transaction coordination and other representation requirements.",
  },
  {
    number: "05",
    title: "Ongoing Support",
    text: "Continued legal guidance helps your business manage contracts, risks, changes and emerging legal requirements.",
  },
];

const benefits = [
  "Legally compliant documentation",
  "Reduced legal and business risks",
  "Faster and clearer contract execution",
  "Stronger intellectual property protection",
  "Professional legal advisory",
  "Commercially practical solutions",
  "Reliable transaction support",
  "Cost-effective legal assistance",
];

const faqs = [
  {
    question: "Do you draft commercial agreements?",
    answer:
      "Yes. We draft business agreements, commercial contracts, employment documents, notices and other legal instruments based on your requirements.",
  },
  {
    question: "Can you review existing contracts?",
    answer:
      "Yes. We review existing contracts, highlight legal and commercial risks, and recommend practical revisions before execution or renewal.",
  },
  {
    question: "Do you support mergers and acquisitions?",
    answer:
      "Yes. We assist with transaction structuring, due diligence coordination, documentation, negotiations and regulatory support for eligible transactions.",
  },
  {
    question: "Can you assist with legal notices and commercial disputes?",
    answer:
      "Yes. We support the preparation and review of legal notices, replies, documentation and commercially practical dispute-management strategies.",
  },
];

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M20 6 9 17l-5-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M5 12h14M13 6l6 6-6 6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ServiceIcon = ({ index }) => {
  const icons = [
    <path key="1" d="M4 21V7l8-4 8 4v14M8 10h2m4 0h2M8 14h2m4 0h2M9 21v-3h6v3" />,
    <path key="2" d="M12 3 4 6v5c0 5 3.4 8.4 8 10 4.6-1.6 8-5 8-10V6l-8-3Zm-3 9 2 2 4-4" />,
    <path key="3" d="M4 5h16v14H4V5Zm0 4h16M8 3v4m8-4v4M8 13h3m2 0h3m-8 3h3" />,
    <path key="4" d="M5 12h14M12 5l3 3-3 3M12 13l-3 3 3 3" />,
    <path key="5" d="M4 18V9m5 9V5m5 13v-7m5 7V3M3 21h18" />,
    <path key="6" d="M4 20h16M6 20V9m12 11V9M3 9h18L12 3 3 9Zm7 4h4m-4 3h4" />,
  ];

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {icons[index]}
      </g>
    </svg>
  );
};

const LegalServices = () => {
  return (
    <Layout header={4} footer={2} breadcrumb="Legal Services" title="Legal Services">
      <main className="legal-page">
        <section className="legal-intro section-space">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6 col-md-10 mx-auto">
                <div className="legal-intro__visual">
                  <img
                    className="legal-intro__main-image"
                    src={LegalSolutions}
                    alt="Corporate legal advisory professionals"
                  />

                  <div className="legal-intro__experience-card">
                    <strong>360°</strong>
                    <span>Business-oriented legal advice and documentation support</span>
                  </div>

                
                </div>
              </div>

              <div className="col-lg-6">
                <div className="legal-section-heading">
                  <span className="legal-eyebrow">Practical Corporate Legal Support</span>
                  <h2>Business-Focused Legal Solutions That Protect Your Interests</h2>
                </div>

                <p className="legal-lead">
                  Every business decision carries legal implications. Our Legal Services provide practical, business-oriented solutions that protect your interests while supporting sustainable growth.
                </p>

                <p>
                  Globiz India delivers legally sound, commercially practical and result-oriented advice for companies, LLPs, promoters, investors, startups and established organisations.
                </p>

                <div className="legal-highlight-list">
                  <div className="legal-highlight-item">
                    <span className="legal-highlight-item__icon">
                      <CheckIcon />
                    </span>
                    <div>
                      <h4>Commercially Practical Legal Advice</h4>
                      <p>Solutions aligned with your transaction, risk profile and business objectives.</p>
                    </div>
                  </div>

                  <div className="legal-highlight-item">
                    <span className="legal-highlight-item__icon">
                      <CheckIcon />
                    </span>
                    <div>
                      <h4>From Drafting to Ongoing Support</h4>
                      <p>End-to-end assistance covering review, documentation, negotiation and follow-up.</p>
                    </div>
                  </div>
                </div>

                <div className="legal-intro__actions">
                  <Link to="/contact" className="legal-btn legal-btn--primary">
                    Discuss Your Legal Requirement <ArrowIcon />
                  </Link>

                 
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="legal-speciality">
          <div className="container-fluid p-0">
            <div className="row g-0 align-items-stretch">
              <div className="col-lg-6 legal-speciality__content-col">
                <div className="legal-speciality__content">
                  <span className="legal-eyebrow legal-eyebrow--light">
                    What We Cover
                  </span>
                  <h2>Legal Protection Across Critical Business Decisions</h2>
                  <p>
                    We identify legal exposure, review important documents and provide clear recommendations that protect your business while keeping commercial priorities in focus.
                  </p>

                  <div className="accordion legal-accordion" id="legalAccordion">
                    <div className="accordion-item">
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#legalOne"
                          aria-expanded="true"
                          aria-controls="legalOne"
                        >
                          Corporate, Commercial and Contract Advisory
                        </button>
                      </h3>
                      <div
                        id="legalOne"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#legalAccordion"
                      >
                        <div className="accordion-body">
                          We assist with entity structuring, business setup planning,
                          promoter advisory, governance frameworks and strategic corporate
                          decisions.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#legalTwo"
                          aria-expanded="false"
                          aria-controls="legalTwo"
                        >
                          Transactions, Restructuring and Intellectual Property
                        </button>
                      </h3>
                      <div
                        id="legalTwo"
                        className="accordion-collapse collapse"
                        data-bs-parent="#legalAccordion"
                      >
                        <div className="accordion-body">
                          Compliance health checks, risk assessments, document reviews
                          and regulatory guidance help strengthen your business framework.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#legalThree"
                          aria-expanded="false"
                          aria-controls="legalThree"
                        >
                          Employment, Real Estate and Dispute Support
                        </button>
                      </h3>
                      <div
                        id="legalThree"
                        className="accordion-collapse collapse"
                        data-bs-parent="#legalAccordion"
                      >
                        <div className="accordion-body">
                          We support transactions, negotiations, process optimization,
                          performance improvement and long-term strategic planning.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 legal-speciality__image-col">
                <img
                  src={whychooseus}
                  alt="Consultants discussing business strategy"
                />
                <div className="legal-speciality__image-overlay">
                  <span>Insight. Strategy. Execution.</span>
                  <strong>Legal advice designed to protect value and support confident decisions.</strong>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="legal-services section-space">
          <div className="container">
            <div className="legal-section-heading legal-section-heading--center">
              <span className="legal-eyebrow">Our Legal Expertise</span>
              <h2>Comprehensive Legal Support for Modern Businesses</h2>
              <p>
                Practical legal assistance tailored to your organisation&apos;s transaction, documentation and risk-management needs.
              </p>
            </div>

            <div className="row g-4">
              {serviceItems.map((item, index) => (
                <div className="col-lg-4 col-md-6" key={item.title}>
                  <article className="legal-service-card">
                    <div className="legal-service-card__icon">
                      <ServiceIcon index={index} />
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                    <Link to="/contact" className="legal-text-link">
                      Get expert guidance <ArrowIcon />
                    </Link>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="legal-benefits section-space">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-5">
                <div className="legal-section-heading">
                  <span className="legal-eyebrow">Why Choose Globiz India</span>
                  <h2>Legally Sound Advice with a Commercial Perspective</h2>
                </div>
                <p>
                  Our multidisciplinary approach gives decision-makers clear,
                  commercially practical and implementation-focused advice rather than
                  generic recommendations.
                </p>
                <Link to="/contact" className="legal-btn legal-btn--dark">
                  Speak with Our Consultants <ArrowIcon />
                </Link>
              </div>

              <div className="col-lg-7">
                <div className="legal-benefits__grid">
                  {benefits.map((benefit) => (
                    <div className="legal-benefit-item" key={benefit}>
                      <span>
                        <CheckIcon />
                      </span>
                      <p>{benefit}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="legal-process section-space">
          <div className="container">
            <div className="legal-section-heading legal-section-heading--center">
              <span className="legal-eyebrow">Our Legal Process</span>
              <h2>A Clear Process from Consultation to Ongoing Support</h2>
            </div>

            <div className="legal-process__track">
              {processSteps.map((step) => (
                <article className="legal-process-card" key={step.number}>
                  <span className="legal-process-card__number">{step.number}</span>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="legal-faq section-space">
          <div className="container">
            <div className="row g-5 align-items-start">
              <div className="col-lg-5">
                <div className="legal-section-heading">
                  <span className="legal-eyebrow">Frequently Asked Questions</span>
                  <h2>Clear Answers About Our Legal Services</h2>
                </div>
                <p>
                  Every business challenge is different. Our team can assess your
                  requirements and recommend the right scope of advisory support.
                </p>
                <Link to="/contact" className="legal-btn legal-btn--primary">
                  Ask Our Consultants <ArrowIcon />
                </Link>
              </div>

              <div className="col-lg-7">
                <div className="accordion legal-faq__accordion" id="legalFaq">
                  {faqs.map((faq, index) => {
                    const collapseId = `legalFaq${index + 1}`;

                    return (
                      <div className="accordion-item" key={faq.question}>
                        <h3 className="accordion-header">
                          <button
                            className={`accordion-button ${index === 0 ? "" : "collapsed"}`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${collapseId}`}
                            aria-expanded={index === 0 ? "true" : "false"}
                            aria-controls={collapseId}
                          >
                            {faq.question}
                          </button>
                        </h3>
                        <div
                          id={collapseId}
                          className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                          data-bs-parent="#legalFaq"
                        >
                          <div className="accordion-body">{faq.answer}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="legal-cta">
          <div className="container">
            <div className="legal-cta__inner">
              <div>
                <span className="legal-eyebrow legal-eyebrow--light">
                  Protect Your Business. Move Forward Confidently.
                </span>
                <h2>Need reliable legal support for your business?</h2>
                <p>
                  Let Globiz India help you protect your interests, reduce legal exposure and proceed with greater commercial confidence.
                </p>
              </div>
              <Link to="/contact" className="legal-btn legal-btn--white">
                Request a Consultation <ArrowIcon />
              </Link>
            </div>
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default LegalServices;
